import type { SiteApplianceEstimate } from "@/domains/site/site.types";

import { z } from "zod";

const actualApplianceSchema = z.object({
  code: z.string().min(1),
  label: z.string(),
  quantity: z.number().min(0),
}) satisfies z.ZodType<SiteApplianceEstimate & { label: string }>;

export const siteAppointmentPreparationDtoSchema = z.object({
  hardwareVersion: z.string(),
  hasVoltalisHardware: z.boolean(),
  installedDeviceNumber: z.number(),
  installedHeatPumpNumber: z.number(),
  radiatorsNumber: z.number().nullable().default(0),
  actualAppliances: z.array(actualApplianceSchema).nullable().optional(),
});

export type TSiteAppointmentPreparationDto = z.infer<typeof siteAppointmentPreparationDtoSchema>;
